import Enum from '@square/dashboard-utilities/utils/enum';
export const DeviceType = new Enum(['RETAIL', 'REGISTER', 'RESTAURANT', 'TERMINAL_API', 'KDS', 'KDS_EXPO', 'RESTAURANT_MOBILE', 'FNBKIOSK']);
export function isRestaurantPosDeviceType(deviceType) {
  return deviceType === DeviceType.RESTAURANT || deviceType === DeviceType.RESTAURANT_MOBILE;
}
export function isKDSDeviceType(deviceType) {
  return deviceType === DeviceType.KDS || deviceType === DeviceType.KDS_EXPO;
}
export function isKioskDeviceType(deviceType) {
  return deviceType === DeviceType.FNBKIOSK;
}